import { Location } from "../queries/auto-generated/schemas";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../ducks";
import { useEffect, useState } from "react";
import { useApolloClient, ApolloQueryResult } from "@apollo/client";
import { LOOKUP_LOCATIONS_WITH_SQUARE_ID } from "../queries/my-queries";
import { LookupLocationWithSquareIdQuery } from "../queries/auto-generated/operations";
import _ from "lodash";
import location from "../ducks/location";

const useLocationLookup = (locationSquareId?: string) => {
  const gqlClient = useApolloClient();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  let foundLocation: Location | undefined = undefined;

  // Check for location in local store
  const locallyStoredLocations = useSelector(
    (state: RootState) => state.location.data.locations
  );
  if(locationSquareId !== undefined) {
    foundLocation = _.find(
      locallyStoredLocations,
      (location) => location.square_id === locationSquareId
    );
  }

  // Check for location from Joo API
  useEffect(() => {
    if (!foundLocation && locationSquareId) {
      setLoading(true);
      gqlClient
        .query({
          query: LOOKUP_LOCATIONS_WITH_SQUARE_ID,
          variables: {
            square_id: locationSquareId,
          },
        })
        .then((result: ApolloQueryResult<LookupLocationWithSquareIdQuery>) => {
          const { data } = result;
          if (!data?.locations || !data?.locations?.[0]) {
            throw new Error("Location not found");
          }
          dispatch(
            location.actions.addLocation(data?.locations?.[0] as Location)
          );
        })
        .catch((error) => console.error({ error }))
        .finally(() => setLoading(false));
    }
  }, [gqlClient, foundLocation, setLoading, dispatch, locationSquareId]);

  return { location: foundLocation, loading };
};

export default useLocationLookup;
